import ActionTypes from './types'
import {listBuildingStaffForBuilding} from '../lib/queries'
import {updateGroupUser, getStaffModel} from '../lib/queries'
import {CACHE_ActiveBuildingId} from '../constants/AppConstants'

/**
 * @param {Dispatch} dispatch
 * @param {*} staffModel
 */
export const setAuthenticatedStaffUser = (dispatch, staffModel) => {
  dispatch({
    type: ActionTypes.STAFF_SET_AUTHED_USER,
    payload: staffModel,
  })
}

/**
 * @param {Dispatch} dispatch
 * @param {*} updateGroupUserInput
 */
export const updateAuthenticatedStaffUser = async (dispatch, updateGroupUserInput) => {
  await updateGroupUser(updateGroupUserInput)
  const updatedStaff = await getStaffModel(updateGroupUserInput.staffId)

  dispatch({
    type: ActionTypes.STAFF_UPDATE_STAFF,
    payload: updatedStaff,
  })
}

/**
 * @param {Dispatch} dispatch
 * @param {string} buildingId
 * @return {Promise<*>}
 */
export async function loadBuildingStaffForBuilding(dispatch, buildingId) {
  let response = await listBuildingStaffForBuilding(buildingId)

  // if we changed buildings between requests, we don't want to update the state
  if (buildingId !== localStorage[CACHE_ActiveBuildingId]) {
    return []
  }

  dispatch({
    type: ActionTypes.STAFF_SET_STAFF_LOOKUP,
    payload: response,
  })

  return response
}
